import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicContactAssistance = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'À propos de Wodzone', link: '/topics/about'},
    { label: 'Fonctionnement de Wodzone', link: '/topics/about/fonctionnement'},
    { label: topic.title, link: topic.link},
  ]

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">Que vous soyez athête ou organisateur, obtenez de l'aide avant, pendant ou après un event.</p>
            <div className="article-container mt-40">
              <p className="help-title-part">{topic.subtitles[0]}</p>
              <p className="help-text">
                Envoyer un message est généralement le moyen le plus rapide et le plus simple pour résoudre un problème lié à votre inscription. 
                Vous pouvez contacter l’organisateur directement par e-mail, si ses coordonnées sont mentionnées dans l’e-mail de confirmation. De plus, la plupart 
                des events étant relayés sur Instagram, vous pouvez également le joindre via cette plateforme.
              </p>
              <p className="help-text">
                Pendant l'event, rendez-vous directement à l'accueil de votre compétition pour rencontrer les membres de l'équipe organisatrice.
              </p>
            </div>
            <div className="article-container mt-56">
              <p className="help-title-part mb-8">{topic.subtitles[1]}</p>
              <p className="help-text">
                Consultez le<a target='_blank' className="link" href="/">Centre d'aide</a>pour trouver des réponses aux questions fréquentes, y compris des infos sur :
              </p>
              <ul>
                <li className="pl-8 mb-8"><p className="help-text"><a target='_blank' className="link" href="#">Lien 1</a></p></li>
                <li className="pl-8 mb-8"><p className="help-text"><a target='_blank' className="link" href="#">Lien 2</a></p></li>
                <li className="pl-8 mb-8"><p className="help-text"><a target='_blank' className="link" href="#">Lien 3</a></p></li>
              </ul>
            </div>
            <div className="article-container mt-56">
              <p className="help-title-part mb-8">{topic.subtitles[2]}</p>
              <p className="help-text">
                Vous avez besoin d'un peu plus d'aide ou vous souhaitez faire une réclamation ?<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/contact`}>Contactez-nous</a>
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicContactAssistance